import * as CONST from "../../../app/constants"
import { isChangeRequestTypeApplication, isRenewalTypeApplication } from "../../slice/applicationsUtils";
import { 
    parseLenderConfirmationInformationForRenewal,
    parseLenderQualificationInformationMap 
} from "./lenderReviewData";
import { 
    getUpdatedDocuemntsWithReviewData,
    isHavingUpdatedDocuments,
    parseAIRInformationForRenewal,
    parseAppointedAgentInformation,
    parseAppointedAgentInformationForRenewal,
    parseCompanyTypeInformationForRenewal,
    parseComplainceOfficerChangeRequestAgentEmail,
    parseCriminalRecordsCheckInformation,
    parseCriminalRecordsCheckInformationForRenewal,
    parseFinancialRecordsInformation,
    parseFinancialRecordsInformationForRenewal,
    parseFinancialStatementsForRenewal,
    parseFiscalYearInformation,
    parseFiscalYearInformationForRenewal,
    parseInsuranceInformation,
    parseInsuranceInformationForRenewal,
    parseLenderOrAdministratorChangeRequestInformation,
    parseMortgageApplicantInformation,
    parseMortgageApplicantInformationForRenewal,
    // parseNotAddedDocumentsInformation,
    parsePrincipalBrokerInformation,
    parsePrincipalBrokerInformationForRenewal,
    parseServiceAddressInformation,
    parseServiceAddressInformationForRenewal, 
    parseUpdatedDocumentsInformation
} from "./bltReviewMortgageApplication";
import { isReviewDataNeeded, parseSuretyBondData } from "../bltReviewSelector";
import { combineAddress } from "../../../app/utils"
import { fullName } from "../../../app/utils"

function parseAdministratorTrustAccountInformationForRenewal(applicationItem, archiveApplicationItem) {
    const reviewData = []

    const { trustAccountInstitution: trustAccountFrom } = archiveApplicationItem
    const {
        name : nameFrom,
        branchName : branchNameFrom,
        accountNumber : accountNumberFrom,
        address : addressFrom, 
        signingOfficers : siginingOfficersFrom,
    } = trustAccountFrom

    const { trustAccountInstitution: trustAccountTo } = applicationItem
    const {
        name : nameTo,
        branchName : branchNameTo,
        accountNumber : accountNumberTo,
        address : addressTo, 
        signingOfficers : siginingOfficersTo,
    } = trustAccountTo

    reviewData.push({
        parameterName : "branchName",
        changeFrom: branchNameFrom,
        changeTo : branchNameTo,
        review: branchNameFrom === branchNameTo ? "complete" : null,
    })

    const fullAddressFrom = combineAddress(addressFrom)
    const fullAddressTo = combineAddress(addressTo)

    reviewData.push({
        parameterName : "address",
        changeFrom: fullAddressFrom,
        changeTo : fullAddressTo,
        review: fullAddressFrom === fullAddressTo ? "complete" : null,
    })

    reviewData.push({
        parameterName : "accountNumber",
        changeFrom: accountNumberFrom,
        changeTo : accountNumberTo,
        review: accountNumberFrom === accountNumberTo ? "complete" : null,
    })

    reviewData.push({
        parameterName : "name",
        changeFrom: nameFrom,
        changeTo : nameTo,
        review: nameFrom === nameTo ? "complete" : null,
    })

    const signingOfficersFromFull = siginingOfficersFrom?.join("\n") ?? ""
    const signingOfficersToFull = siginingOfficersTo?.join("\n") ?? ""

    reviewData.push({
        parameterName : "signingOfficers",
        changeFrom: signingOfficersFromFull,
        changeTo : signingOfficersToFull,
        review: signingOfficersFromFull === signingOfficersToFull ? "complete" : null,
    })

    if (reviewData.every(obj => obj.review === "complete")) {
        reviewData[0].review = null
        reviewData[0].forceSelection = true
    }

    return reviewData
}

function parseAdministratorTrustAccountInformation(applicationItem, documents) {
    const { trustAccountInstitution } = applicationItem
    const {
        name,
        branchName,
        accountNumber,
        address, 
        signingOfficers,
    } = trustAccountInstitution

    // const financialDocuments = documents.filter(d => d.documentType === DOCUMENT_TYPE_FINANCIAL_STATEMENT_LETTER)

    const reviewData = []

    reviewData.push({
        "Financial institution" : branchName ?? "",
        "review" : ""
    })

    reviewData.push({
        "Branch address" : address ? combineAddress(address) : "",
        "review" : ""
    })

    reviewData.push({
        "Account number" : accountNumber ?? "",
        "review" : ""
    })

    reviewData.push({
        "Name on account" : name ?? "",
        "review" : ""
    })

    reviewData.push({
        "Signing officers" : signingOfficers ? signingOfficers.join("\n") : "",
        "review" : ""
    })

    // financialDocuments.forEach(doc => {
    //     reviewData.push({
    //         ...doc,
    //         "document" : 1,
    //         "review" : ""
    //     })
    // })

    return reviewData
}

function parseAdministratorConfirmationInformation(applicationItem) {
    const businessContact = applicationItem?.complianceOfficer ?? applicationItem?.mainBusinessContact

    return [{
        duty: `I, ${fullName(businessContact)} confirm that I am engaged with the activities with the mortgage administrator to the extent I am capable of carrying out my duties and responsibilites as Compliance Officer under the Mortgage Regulation Act and its regulations.`,
        confirmation: true,
        review : ""
    }, {
        duty: `I, ${fullName(businessContact)} confirm that I have read and understand the Mortgage Regulation Act and its regulations and I agree to carry out my duties and responsibilities under the Act and its regulations.`,
        confirmation: true,
        review : ""
    }]
}

export function administratorReviewDataDetails(
    queueItem, 
    primaryAgencyApplication) 
{
    let sectionsByOrder = []; 
    let businessLicenceData = {};
    const commonSections =  ["internalNotesMap","decisionMap"];

    if(queueItem?.licencingSubType === 
        CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION) {
        businessLicenceData = primaryAgencyApplication.application?.businessLicenceData

        sectionsByOrder = [
            "applicantInformationMap",
            "principalBrokerInformationMap",
            "financialRecordsInformationMap",
            "appointedAgentInformationMap",
            "serviceAddressInformationMap",
            "trustAccountInformationMap",
            "criminalRecordsCheckInformationMap",
            "insuranceInformationMap",
            "fiscalYearInformationMap",
            "suretyBondDataMap",
            "confirmationInformationMap",
        ]
    } else if(queueItem?.licencingSubType === 
                CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION) {
        businessLicenceData = primaryAgencyApplication.application?.businessLicenceData

        sectionsByOrder = [
            "applicantInformationMap",
            "principalBrokerInformationMap",
            "brokerQualificationInformationMap",
            "airInformationMap",
            "companyTypeInformationMap",
            "financialRecordsInformationMap",
            "financialStatementsInformationMap",
            "appointedAgentInformationMap",
            "serviceAddressInformationMap",
            "trustAccountInformationMap",
            "criminalRecordsCheckInformationMap",
            "insuranceInformationMap",
            "fiscalYearInformationMap",
            "confirmationInformationMap",
        ]
    } else if(queueItem?.licencingSubType === 
        CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_CHANGE_APPLICATION) {
        businessLicenceData = primaryAgencyApplication.application?.businessLicenceData

        sectionsByOrder = [
            "changeRequestDetailsMap",
            "changeRequestNewAgentEmailMap",
        ]
    }

    if (isHavingUpdatedDocuments(queueItem)) {
        if(queueItem?.licenceStatus === CONST.LICENCE_STATUS_ACTIVE) {
            //Ignoring other sections for ACTIVE licence status
            sectionsByOrder = ["updatedDocumentsMap", ...commonSections];
        }
        else {
            sectionsByOrder = [...sectionsByOrder, "updatedDocumentsMap", ...commonSections];
        }
    } else {
        sectionsByOrder = [...sectionsByOrder, ...commonSections];
    }
    
    return {businessLicenceData, sectionsByOrder};
}

export function bltMortgageAdministratorReviewData(administratorApplication, agencyApplicationArchive) { 
    const applicationItem = administratorApplication.businessLicenceData
    const { documents } = administratorApplication

    if(isReviewDataNeeded(applicationItem)) {

        const isRenewal = isRenewalTypeApplication(administratorApplication)

        let applicantInformationMap = [{}]
        let principalBrokerInformationMap = [{}]
        let financialRecordsInformationMap = [{}]
        let appointedAgentInformationMap = [{}]
        let serviceAddressInformationMap = [{}]
        let trustAccountInformationMap = [{}]
        let criminalRecordsCheckInformationMap = [{}]
        let insuranceInformationMap = [{}]
        let suretyBondDataMap = [{}]
        let confirmationInformationMap = [{}]
        let fiscalYearInformationMap = [{}]
        let companyTypeInformationMap = [{}]
        let airInformationMap = [{}]
        let brokerQualificationInformationMap = [{}]
        let changeRequestDetailsMap = [{}]
        let changeRequestNewAgentEmailMap = [{}]
        let financialStatementsInformationMap = [{}]
        
        if(isRenewal) {
            const applicationItemArchive = agencyApplicationArchive?.businessLicenceData

            // const applicantInformationMap = parseMortgageBrokerInformation(applicationItem)
            applicantInformationMap = parseMortgageApplicantInformationForRenewal(applicationItem,applicationItemArchive)
            principalBrokerInformationMap = parsePrincipalBrokerInformationForRenewal(applicationItem,applicationItemArchive)
            brokerQualificationInformationMap = parseLenderQualificationInformationMap(applicationItem)
            financialRecordsInformationMap = parseFinancialRecordsInformationForRenewal(applicationItem,applicationItemArchive)
            appointedAgentInformationMap = parseAppointedAgentInformationForRenewal(applicationItem,applicationItemArchive)
            serviceAddressInformationMap = parseServiceAddressInformationForRenewal(applicationItem,applicationItemArchive)
            trustAccountInformationMap = parseAdministratorTrustAccountInformationForRenewal(applicationItem,applicationItemArchive)
            criminalRecordsCheckInformationMap = parseCriminalRecordsCheckInformationForRenewal(applicationItem,documents,agencyApplicationArchive)
            insuranceInformationMap = parseInsuranceInformationForRenewal(applicationItem, documents)
            confirmationInformationMap = parseLenderConfirmationInformationForRenewal(applicationItem)
            fiscalYearInformationMap = parseFiscalYearInformationForRenewal(applicationItem,applicationItemArchive)
            companyTypeInformationMap = parseCompanyTypeInformationForRenewal(applicationItem,applicationItemArchive)
            airInformationMap = parseAIRInformationForRenewal(applicationItem, documents)
            financialStatementsInformationMap = parseFinancialStatementsForRenewal(applicationItem)
        }
        else {
            if(!isChangeRequestTypeApplication(administratorApplication)) {
            // applicantInformationMap = parseMortgageBrokerInformation(applicationItem)
                applicantInformationMap = parseMortgageApplicantInformation(applicationItem)
                principalBrokerInformationMap = parsePrincipalBrokerInformation(applicationItem)
                financialRecordsInformationMap = parseFinancialRecordsInformation(applicationItem)
                appointedAgentInformationMap = parseAppointedAgentInformation(applicationItem)
                serviceAddressInformationMap = parseServiceAddressInformation(applicationItem)
                trustAccountInformationMap = parseAdministratorTrustAccountInformation(applicationItem, documents)
                criminalRecordsCheckInformationMap = parseCriminalRecordsCheckInformation(applicationItem,documents)
                insuranceInformationMap = parseInsuranceInformation(applicationItem, documents)
                suretyBondDataMap = parseSuretyBondData(applicationItem)
                confirmationInformationMap = parseAdministratorConfirmationInformation(applicationItem)
                fiscalYearInformationMap = parseFiscalYearInformation(applicationItem)
            } else {
                changeRequestDetailsMap = parseLenderOrAdministratorChangeRequestInformation(applicationItem);
                changeRequestNewAgentEmailMap = parseComplainceOfficerChangeRequestAgentEmail(applicationItem)
            }
        }
        
        const decisionMap = [{
            adminDecision : "",
            review : ""
        }]

        const internalNotesMap = [{
            internalNotes : applicationItem.internalNotes,
            review : (applicationItem.internalNotes?.length > 0) ? "complete" : "" 
        }]

        const reviewMaps = {
            applicantInformationMap,
            companyTypeInformationMap,
            brokerQualificationInformationMap,
            airInformationMap,
            principalBrokerInformationMap,
            financialRecordsInformationMap,
            financialStatementsInformationMap,
            appointedAgentInformationMap,
            serviceAddressInformationMap,
            trustAccountInformationMap,
            criminalRecordsCheckInformationMap,
            insuranceInformationMap,
            fiscalYearInformationMap,
            suretyBondDataMap,
            confirmationInformationMap,
            changeRequestDetailsMap,
            changeRequestNewAgentEmailMap,
            internalNotesMap,
            decisionMap 
        }

        // const documentsContainingMaps = {
        //     insuranceInformationMap,
        //     criminalRecordsCheckInformationMap,
        //     airInformationMap
        // }
        // const updatedDocumentsNotAdded = parseNotAddedDocumentsInformation(applicationItem, documentsContainingMaps, documents);
        
        const updatedDocumentsNotAdded = parseUpdatedDocumentsInformation(applicationItem, documents);
        if(updatedDocumentsNotAdded?.length) {
            reviewMaps.updatedDocumentsMap = updatedDocumentsNotAdded
        }

        return reviewMaps;
    }
    else if (isHavingUpdatedDocuments(administratorApplication)) {
        applicationItem.reviewDataCollectionDebt = getUpdatedDocuemntsWithReviewData(applicationItem, documents, administratorApplication.licenceStatus)
    }
    return applicationItem.reviewDataCollectionDebt
}